import { render, staticRenderFns } from "./VictoryMatch.vue?vue&type=template&id=4e431e76&scoped=true&"
import script from "./VictoryMatch.vue?vue&type=script&lang=js&"
export * from "./VictoryMatch.vue?vue&type=script&lang=js&"
import style0 from "./VictoryMatch.vue?vue&type=style&index=0&id=4e431e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e431e76",
  null
  
)

export default component.exports